import * as React from "react";
import { connect } from "react-redux";
import { ReduxState } from "../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { PolicyDetails } from "../../../../../../store/Policies/Types";
import { VehicleView } from "../component/VehicleView";
import { LoadingData } from "@vwpfs/mary-air-lib/components/air/09-views/00-blocks/LoadingData";

/**
 *
 */
interface StateProps {
    formData: PolicyDetails;
}

/**
 *
 */
type Props = StateProps;

/**
 *
 * @param props
 */
export class VehicleComp
    extends React.Component<Props, {}> {


    public constructor(props: Props) {
        super(props);
    }
    public static mapStateToProps(s: ReduxState): StateProps {
        return {
            formData: s.prop("remote").prop(RemoteScope.POLICY_DETAILS),
        };
    }


    public render() {
        const vehicle = this.props.formData &&
            this.props.formData.content ?
            this.props.formData.content : undefined;
        return (
            vehicle ? (
                <VehicleView general={vehicle}/>
            ) : (
                <LoadingData loading={false} />
            )
        );
    }
}

/**
 *
 */
export const Vehicle = connect(
    VehicleComp.mapStateToProps,
    {},
)(VehicleComp);
